import script from "./DecorationTechniqueVariants.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationTechniqueVariants.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationTechniqueVariants.vue?vue&type=style&index=0&id=3466c5de&lang=css"

const __exports__ = script;

export default __exports__